import { dispatch } from '../store/'

export const onFetchUser = (userProfile) => {
    const actionCreator =  {
        type: 'FETCH_USER',
        userProfile: userProfile
    }
    dispatch(actionCreator)
    return Promise.resolve('onFetchUser')
  }




// WEBPACK FOOTER //
// ./src/actions/user.js